/* import __COLOCATED_TEMPLATE__ from './teammate-assignee-result-row.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: any;
}

const TeammateAssigneeResultRow = templateOnlyComponent<Signature>();
export default TeammateAssigneeResultRow;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::TeammateAssigneeResultRow': typeof TeammateAssigneeResultRow;
    'inbox2/conversation-details-sidebar/teammate-assignee-result-row': typeof TeammateAssigneeResultRow;
  }
}
